import { ReactNode, useCallback, useId } from 'react';
import { cn } from 'v5/platform/dom/cn';
import { useDismissableLayerFix } from 'v5/platform/react/useDismissableLayerFix';

export function useColorPickerDismissFix(
  isOpen: boolean,
  onOpenChange: (open: boolean) => void
) {
  const pickerId = useId();
  const handleClose = useCallback(() => {
    onOpenChange(false);
  }, [onOpenChange]);

  useDismissableLayerFix(isOpen, handleClose, [
    `[data-color-picker-popover="${pickerId}"]`,
    `[data-color-picker-root="${pickerId}"]`
  ]);

  return {
    rootProps: { 'data-color-picker-root': pickerId },
    popoverProps: { 'data-color-picker-popover': pickerId }
  };
}

export function ColorSwatchPreview({
  hex,
  render,
  className
}: {
  hex?: string;
  render?: ReactNode;
  className?: string;
}) {
  if (render) {
    return (
      <span
        className={cn(
          'flex size-5 shrink-0 items-center justify-center overflow-hidden rounded-full ring-1 ring-border-default',
          className
        )}
      >
        {render}
      </span>
    );
  }

  if (hex) {
    return (
      <span
        className={cn(
          'size-5 shrink-0 rounded-full ring-1 ring-border-default',
          className
        )}
        style={{ backgroundColor: hex }}
      />
    );
  }

  return (
    <span
      className={cn(
        'size-5 shrink-0 rounded-full bg-bg-subtle ring-1 ring-border-default',
        className
      )}
    />
  );
}
